import { Reveal } from "./Reveal";

const cards = [
  {
    id: "refined-lead",
    symbol: "Pb 99.97%+",
    title: "Refined Lead",
    blurb:
      "High-purity refined lead (99.97%+) recovered from lead-bearing scrap and spent batteries, cast into clean Metalix-embossed ingots.",
    tags: ["99.97%+ purity", "Ingots", "Battery-grade"],
    image: "/product-refined-lead.png",
  },
  {
    id: "lead-alloys",
    symbol: "Pb-Sb / Pb-Ca",
    title: "Lead Alloys",
    blurb:
      "Custom antimonial and calcium lead alloys, blended and verified to precise customer chemistry for battery and industrial use.",
    tags: ["Antimonial", "Calcium", "Custom spec"],
    image: "/product-lead-alloys.png",
  },
];

const Card = ({ card }) => (
  <div
    data-testid={`product-${card.id}`}
    data-cursor="view"
    className="group overflow-hidden rounded-2xl border border-[var(--mx-line)] bg-[var(--mx-surface)] shadow-[0_20px_60px_-50px_rgba(27,23,20,0.5)] transition-[transform,box-shadow] duration-500 hover:-translate-y-1 hover:shadow-[0_30px_70px_-45px_rgba(27,23,20,0.45)]"
  >
    <div className="relative aspect-[4/3] overflow-hidden bg-[var(--mx-surface-2)]">
      <img
        src={card.image}
        alt={`${card.title} ingots embossed with Metalix`}
        className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
      />
      <span className="absolute right-4 top-4 rounded-full bg-[var(--mx-bg)]/85 px-3 py-1 font-mono-tech text-[10px] uppercase tracking-widest text-[var(--mx-copper)] backdrop-blur-md">
        {card.symbol}
      </span>
    </div>
    <div className="p-7 md:p-9">
      <div className="mb-3 font-mono-tech text-xs uppercase tracking-widest text-[var(--mx-ink-2)]">
        Product
      </div>
      <h3 className="font-display text-4xl font-extrabold uppercase leading-none tracking-tight text-[var(--mx-ink)] md:text-5xl">
        {card.title}
      </h3>
      <p className="mt-4 max-w-md text-sm leading-relaxed text-[var(--mx-ink-2)]">
        {card.blurb}
      </p>
      <div className="mt-5 flex flex-wrap gap-2">
        {card.tags.map((t) => (
          <span
            key={t}
            className="rounded-full border border-[var(--mx-line-strong)] px-3 py-1 font-mono-tech text-[10px] uppercase tracking-widest text-[var(--mx-ink-2)]"
          >
            {t}
          </span>
        ))}
      </div>
    </div>
  </div>
);

export const Products = () => (
  <section
    id="products"
    data-testid="products-section"
    className="mx-auto max-w-[1400px] px-6 py-28 md:px-10 md:py-40"
  >
    <Reveal>
      <div className="mb-14 flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
        <div>
          <div className="mb-5 flex items-center gap-4 font-mono-tech text-xs uppercase tracking-[0.25em] text-[var(--mx-ink-2)]">
            <span className="h-px w-10 bg-[var(--mx-copper)]" />
            01 — Products
          </div>
          <h2 className="max-w-2xl font-display text-5xl font-black uppercase leading-[0.9] tracking-tighter text-[var(--mx-ink)] md:text-7xl">
            What we make
          </h2>
        </div>
        <p className="max-w-sm text-sm leading-relaxed text-[var(--mx-ink-2)]">
          A focused range of recycled lead products — refined lead and custom
          lead alloys — cast and embossed under the Metalix mark.
        </p>
      </div>
    </Reveal>

    <Reveal delay={0.1}>
      <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
        {cards.map((c) => (
          <Card key={c.id} card={c} />
        ))}
      </div>
    </Reveal>
  </section>
);

export default Products;
